import { Component, EventEmitter, Input, Output, TrackByFunction } from '@angular/core';
import { NgForOf, NgIf } from '@angular/common';
import { DocumentsFilter } from '../documents-page/documents-page.types';
import { UniqueDocumentTypesPipe } from './unique-document-types.pipe';
import { DocumentTypesKeys, DocumentType } from '../../../core/modules/documents/documents.types';

@Component({
  selector: 'tax-document-types',
  templateUrl: './document-types.component.html',
  standalone: true,
  imports: [
    NgForOf,
    NgIf,
    UniqueDocumentTypesPipe,
  ],
  styleUrls: ['./document-types.component.sass'],
})
export class DocumentTypesComponent {
  @Input() documentTypes: DocumentType[] = [];
  @Output() selectDocumentType = new EventEmitter<DocumentsFilter>();

  selectedDocumentTypes = new Set<DocumentTypesKeys>();

  readonly documentTypesTrackBy: TrackByFunction<DocumentType> = (index: number, item: DocumentType) => item?.shortName;
  // В фильтре отображаем только уникальные именования, но фильтруем по всем типам
  // Т.е. если есть CONTRACT: { ... shortName: "Заявка №2", ... }
  // и CONTRACT_QR_CODE: { ... shortName: "Заявка №2", ...}, то отображаем "Заявка №2" только один раз в фильтре.
  // Но если этот фильтр будет активен, то в фильтре ищем и CONTRACT и CONTRACT_QR_CODE
  setSelectedDocumentTypes(clickedType: string):void {
    const clickedDocumentTypeKeys: DocumentTypesKeys[] = this.documentTypes
      .filter(documentType => documentType.shortName === clickedType && Boolean(documentType.attachment))
      .map(documentType => documentType.attachment);

    clickedDocumentTypeKeys.forEach((clickedDocumentTypeKey) => {
      if (this.selectedDocumentTypes.has(clickedDocumentTypeKey)) {
        this.selectedDocumentTypes.delete(clickedDocumentTypeKey);
      } else {
        this.selectedDocumentTypes.add(clickedDocumentTypeKey);
      }
    });

    const documentType: DocumentTypesKeys[] = Array.from(this.selectedDocumentTypes);
    this.selectDocumentType.emit({
      documentType,
    });
  }
}
